var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-is-primary"},[_c('label',[_c('input',{staticClass:"pb-3",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.handleCheckboxChange}}),_c('span',{staticClass:"help"},[_vm._v("Is Primary")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }